module.exports = __webpack_public_path__ + "static/media/allergen_sulphurdioxide.f92936a7.png";